import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { createComment, deleteComment, updateComment } from 'api/Comment';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

export const useComment = (category, id, _extraParams = {}) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const handleSuccess = () => {
    try {
      queryClient.invalidateQueries({ queryKey: ['activities', category, id] });
    } catch (error) {
      console.error('Error updating queryClient activities', error);
    }
  };

  const { mutate: createCommentHandler, isLoading: isCreatingComment } = useCustomMutation({
    mutationFn: (params) => createComment(navigate, params),
    successMessage: 'Comment created successfully!',
    errorMessage: 'Failed to create comment. Please try again.',
    onSuccess: handleSuccess
  });

  const { mutate: deleteCommentHandler } = useCustomMutation({
    mutationFn: (params) => deleteComment(navigate, params),
    successMessage: 'Comment deleted successfully!',
    errorMessage: 'Failed to delete comment. Please try again.',
    onSuccess: handleSuccess
  });

  const { mutate: updateCommentHandler } = useCustomMutation({
    mutationFn: (params) => updateComment(navigate, params),
    successMessage: 'Comment updated successfully!',
    errorMessage: 'Failed to update comment. Please try again.',
    onSuccess: handleSuccess
  });

  const onCommentPostHandler = async (value) => {
    await createCommentHandler({ refId: id, refTable: category, value });
  };

  const onCommentDeleteHandler = async (commentId) => {
    await deleteCommentHandler({ id: commentId });
  };

  const onCommentSaveHandler = async (comment) => {
    await updateCommentHandler({ id: comment.id, value: comment.value });
  };

  return {
    isCreatingComment,
    onCommentPostHandler,
    onCommentDeleteHandler,
    onCommentSaveHandler
  };
};
